import { Link } from 'react-router-dom';
import { ArrowRight, Compass } from 'lucide-react';
import { SERVICES_ECO_PROMO } from '@/data/services';
import { SlashMark } from '../AmdenMark';
import { Reveal } from '../Reveal';

// Section 5 — premium navy promo band for the Amden Ecosystem. Highlights
// only; never repeats the full catalogue.
export const EcosystemPromo = () => (
  <section aria-labelledby="eco-promo-heading" data-testid="services-ecosystem-promo" className="relative overflow-hidden bg-navy-900 py-16 sm:py-24">
    <div className="grain-overlay" aria-hidden="true" />
    <SlashMark
      className="pointer-events-none absolute -right-16 -top-16 h-72 w-72 opacity-[0.07]"
      bar="#ffffff"
      dot="#FFB800"
    />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-16">
        <Reveal>
          <p className="flex items-center gap-3">
            <span className="font-mono text-xs font-medium tracking-widest text-gold-500">05</span>
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-gold-500">
              {SERVICES_ECO_PROMO.eyebrow}
            </span>
          </p>
          <h2 id="eco-promo-heading" data-testid="eco-promo-heading" className="mt-4 text-balance text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
            {SERVICES_ECO_PROMO.heading}
          </h2>
          <p className="mt-4 max-w-xl text-base leading-relaxed text-slate-300 sm:text-lg">
            {SERVICES_ECO_PROMO.copy}
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to={SERVICES_ECO_PROMO.primaryHref}
              data-testid="eco-promo-explore-btn"
              className="group inline-flex items-center justify-center gap-2 rounded-md bg-gold-600 px-6 py-3.5 text-sm font-bold text-navy-950 transition-colors hover:bg-gold-500"
            >
              {SERVICES_ECO_PROMO.primaryLabel}
              <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" aria-hidden="true" />
            </Link>
            <Link
              to={SERVICES_ECO_PROMO.secondaryHref}
              data-testid="eco-promo-help-btn"
              className="inline-flex items-center justify-center gap-2 rounded-md border-2 border-white/30 px-6 py-3 text-sm font-bold text-white transition-colors hover:border-white hover:bg-white hover:text-navy-900"
            >
              {SERVICES_ECO_PROMO.secondaryLabel}
            </Link>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <ul className="grid gap-3 sm:grid-cols-2" data-testid="eco-promo-highlights">
            {SERVICES_ECO_PROMO.highlights.map((h) => (
              <li
                key={h}
                className="flex items-center gap-3 rounded-lg border border-white/10 bg-white/5 px-4 py-3.5 text-sm font-semibold text-slate-200"
              >
                <Compass className="h-4 w-4 shrink-0 text-gold-500" aria-hidden="true" />
                {h}
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </div>
  </section>
);
